/**
 * Global API configuration.
 * Resolves the backend base URL dynamically based on the current environment and origin.
 */

const getBackendBaseUrl = (): string => {
  // 1) Explicit environment variables take precedence
  const envUrl = (process.env.REACT_APP_API_URL as string | undefined) ||
                 (import.meta as any).env?.VITE_API_URL;
  
  if (envUrl) return envUrl.endsWith('/') ? envUrl.slice(0, -1) : envUrl;

  // 2) Dynamic resolution for tunnels/relays
  // If we are not on localhost or 127.0.0.1, assume the backend is at the same origin /api
  const { hostname, origin } = window.location;
  if (hostname !== 'localhost' && hostname !== '127.0.0.1' && hostname !== '0.0.0.0') {
    return origin; // We'll append /api or similar in the services if needed, but for file URLs we might need origin
  }

  // 3) Default fallback for local development
  return "http://localhost:8000";
};

export const BACKEND_URL = getBackendBaseUrl();
export const API_BASE_URL = `${BACKEND_URL}/api`;
